import React from 'react';
import LoginPageForm from './components/loginPageForm';

const AdminLoginPage = () => {
  return (
    <LoginPageForm/>
  );
};

export default AdminLoginPage;
